import React from 'react';
import Toast from './Toast';

const ToastContainer = ({ toasts, removeToast }) => {
  return (
    <>
      {toasts.map((toast, index) => (
        <div key={toast.id} style={{ position: 'fixed', bottom: `${20 + index * 80}px`, left: '50%', transform: 'translateX(-50%)', zIndex: 999999 }}>
          <Toast
            message={toast.message}
            type={toast.type}
            duration={toast.duration}
            actionLabel={toast.actionLabel}
            onAction={toast.onAction}
            onClose={() => removeToast(toast.id)}
          />
        </div>
      ))}
    </>
  );
};

export default ToastContainer;
